import {
  FormFieldsByUniqueID,
  SimpleFormField,
} from 'components/form/formTypes'
import { GeckoToggleForm } from 'components/form/GeckoToggleForm'
import { forwardRef } from 'react'
import { SubmitHandler } from 'react-hook-form'

interface CreateCaseFormProps {
  formFields: FormFieldsByUniqueID[]
  inEditMode: boolean
  onSubmit: SubmitHandler<SimpleFormField>
}

export const CreateCaseForm = forwardRef<HTMLFormElement, CreateCaseFormProps>(
  ({ formFields, inEditMode, onSubmit }, ref) => {
    return (
      <GeckoToggleForm
        formFieldsByUniqueID={formFields}
        inEditMode={inEditMode}
        onSubmit={onSubmit}
        ref={ref}
        numberOfColumns={2}
        resetOnSubmit={false}
      />
    )
  }
)

CreateCaseForm.displayName = 'CreateCaseForm'
